import { useEffect, useState } from 'react';

const ANALYSIS_STEPS = [
  'Lecture et analyse du document…',
  'Examen des dates, reconduction et préavis…',
  'Détection des missions cochées et des options…',
  'Finalisation de la synthèse…',
];

export function useContractAiAnalyzing() {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentStepIndex((prev) => (prev + 1) % ANALYSIS_STEPS.length);
    }, 2800);

    return () => clearInterval(timer);
  }, []);

  return {
    currentStepIndex,
    totalSteps: ANALYSIS_STEPS.length,
    currentStepMessage: ANALYSIS_STEPS[currentStepIndex],
  };
}
